import axios from 'axios'
import { $, $1, each } from '../util'

const DownloadsManager = (() => {
  const init = () => {
    const contactsForm = $('.js-downloads-form')

    each(contactsForm, (index, form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault()

        const errorContainer = form.querySelector('.js-downloads-error-message')
        const overlay = form.querySelector('.c-contacts-form__overlay')
        const overlaySuccess = form.querySelector('.c-contacts-form__overlay-success')

        overlay.classList.add('is-loading')

        const values = {}
        for (let i = 0; i < form.elements.length; i += 1) {
          const el = form.elements[i]
          values[el.name] = el.type === 'checkbox' ? el.checked : el.value
        }

        const endpoint = form.getAttribute('data-endpoint')
        const redirect = form.getAttribute('data-redirect')
        const lang = form.getAttribute('data-language')
        const data = new FormData()
        data.append('nome', values.nome)
        data.append('cognome', values.cognome)
        data.append('email', values.email)
        data.append('azienda', values.azienda)
        data.append('newsletter', values.newsletter ? 'CHECKED' : 'NOT CHECKED')
        data.append('lang', document.querySelector('html').getAttribute('lang'))

        axios({
          method: 'post',
          url: endpoint,
          data,
        })
        .then((response) => {
          overlay.classList.remove('is-loading')

          errorContainer.innerText = ''
          errorContainer.classList.remove('is-error')
          overlaySuccess.classList.remove('is-success')

          if (response.data.result) {
            // overlaySuccess.classList.add('is-success')

            // setTimeout(() => {
            //   overlaySuccess.classList.remove('is-success')
            // }, 3200)

            window.location = redirect
          } else {
            errorContainer.innerText = response.data.error
            errorContainer.classList.add('is-error')
          }
        })
        .catch((err) => {
          overlay.classList.remove('is-loading')
          console.log(err)
        })
      })
    })
  }

  return {
    init,
  }
})()

export default DownloadsManager
